import React, { useCallback, useState } from "react";
import { css } from "@emotion/react";
import OutsideClickHandler from "react-outside-click-handler";
import { Link } from "react-router-dom";

import ProfileIcon from "core/Components/Icons/ProfileIcon";
import { useAppState } from "core/contexts/AppContext";

const ProfileButton: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [appState] = useAppState();

    const onClickLogOut = useCallback(() => {
        appState.clearUser();
        setIsOpen(false);
    }, [appState]);

    return (
        <div css={profileContainerStyle}>
            <ProfileIcon
                css={profileIconStyle({ isOpen })}
                onClick={() => setIsOpen((prev: boolean) => !prev)}
            />
            {isOpen && (
                <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
                    <div css={menuStyle}>
                        <Link to={"/profile"}>
                            <div css={profileStyle} onClick={() => setIsOpen(false)}>
                                Profile
                            </div>
                        </Link>
                        <div onClick={onClickLogOut}>
                            Log out
                        </div>
                    </div>
                </OutsideClickHandler>
            )}
        </div>
    );
};

const profileContainerStyle = css`
    position: relative;
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
`;

const menuStyle = css`
    position: absolute;
    top: 100%;
    left: 50%;
    width: 200px;
    transform: translate(-50%);
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    
    > div, a {
        width: 100%;
        display: flex;
        justify-content: center;
        background-color: grey;
        
        &:hover {
            background-color: darkgray;
        }
    }
`;

const profileStyle = css`
    display: flex;
    flex-grow: 1;
    justify-content: center;
`;

const profileIconStyle = ({ isOpen = false } = {}) => css`
    ${isOpen && css`
        pointer-events: none;
    `};
`;

export default ProfileButton;